/* es5-ext/function/is-arguments.js */ function _(require, module, exports) {
    var objToString = Object.prototype.toString, id = objToString.call((function () { return arguments; })());
    module.exports = function (value) { return objToString.call(value) === id; };
}
